
import React from "react";
import pic8 from "../assets/checkmark.png";
import { experienceData } from "../data/experience";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

const Experience = () => {
  const { t } = useTranslation();
  return (
    <section id="experience">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6 }}
      >
        <p className="section__text__p1">{t("exp_subtitle")}</p>
        <h1 className="title">{t("experience_title")}</h1>
      </motion.div>
      <div className="experience-details-container">
        {experienceData.map((category, index) => (
          <motion.div 
            className="details-container card-hover" 
            key={index}
            initial={{ opacity: 0, y: 35 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.6, delay: index * 0.12 }}
            whileHover={{ y: -6, scale: 1.01 }}
          >
            <h2 className="experience-sub-title">{t(category.category)}</h2>
            <div className="article-container">
              {category.skills.map((skill, i) => (
                <motion.article 
                  key={i} 
                  className="experience-item"
                  whileHover={{ x: 4 }}
                  transition={{ type: "spring", stiffness: 400 }}
                >
                  <img src={pic8} alt="Experience icon" className="icon" />
                  <div className="experience-item__content">
                    <h3 className="experience-item__title">{skill.name}</h3>
                    <p>{t(skill.level)}</p>
                  </div>
                </motion.article>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
